<!--
 * @Description: 医院列表页
 * @FilePath: packages/vue-m-comprehensive/src/views/HospitalList/index.vue
 * @url: /v-m-hospital-list/hospital-list
-->
<template>
  <div
    :class="{
      'hospital-content': true,
    }"
  >
    <search-input
      :value="query"
      :placeholder="'输入地区、医院、科室、疾病'"
      @update:value="query = $event"
      @keypress="queryHospitalList"
    />
    <div
      id="hospital-warp"
      :class="{
        'hospital-warp': true,
        'scroll-auto': fromType !== '5' && fromType !== '4',
      }"
    >
      <img
        v-if="fromType === '5' || fromType === '4'"
        id="sort-edu-img"
        class="sort-edu-img"
        src="https://staff.chunyu.mobi/@/media/images/2021/12/28/a212/77ca5da71ee1_w1242_h432_.png"
        alt="banner图"
      />
      <div
        id="filter"
        :class="{
          filter: true,
          fixed: fromType !== '5' && fromType !== '4',
          'margin-bot':
            queryInfo.clinic_name || fromType === '1' || fromType === '3',
        }"
      >
        <FilterSelect
          :value="filterValue"
          :filter-options="filterOptions"
          :mount-element="'hospital-warp'"
          :is-height-filter="isHeightFilter"
          @change="onFilterChange"
          @onClose="onClose"
          @optionItemChange="optionItemChange"
        />
      </div>
      <div class="filter pacter" />
      <div v-if="fromType === '1' || fromType === '3'" class="sort-edu">
        <img
          src="https://staff.chunyu.mobi/@/media/images/2021/12/21/0ccf/32bdb13a135e_w39_h39_.png"
          alt="排名"
        />
        <span>
          医院排名由复旦大学医学管理研究所认证
        </span>
      </div>
      <div v-if="queryInfo.clinic_name" class="hospital-disease-tips">
        {{ queryInfo.query }}属于{{ queryInfo.clinic_name }}领域
      </div>
      <div class="hospital-list-warp">
        <List
          ref="list"
          :mount-element="'hospital-warp'"
          :is-no-data="!hospitalList.length"
          :no-data-icon="
            'https://staff.chunyu.mobi/@/media/images/2021/12/22/4510/29fccc141f91_w120_h80_.png'
          "
          :no-data-message="
            fromType === '3'
              ? '暂无匹配的上榜医院'
              : '更多医院信息，正努力收集中~'
          "
          :finished-text="!isMore && hospitalList.length ? '暂无更多' : ''"
          :loading="isLoading"
          @onLoad="loadMore"
        >
          <hospital-card
            v-for="(item, index) in hospitalList"
            :key="index"
            :hospital-info="{ ...item, index }"
            @click="onHospitalCard"
          />
        </List>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import SearchInput from '@@/components-business-m/src/search-input/index.vue';
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
// eslint-disable-next-line import/no-extraneous-dependencies
import { visitRecordReport } from '@@/utils/pageVisitRecord.js';
import {
  searchHospital,
  getLocation,
  searchClinicList,
  searchOptionList,
} from '@/services/index';
import { doPoint } from '@/utils/index';
import List from '@/components/List';
import FilterSelect from '@/components/FilterSelect';
import HospitalCard from './components/HospitalCard.vue';

const wx = require('weixin-js-sdk');

export default {
  name: 'HospitalList',
  components: { SearchInput, HospitalCard, List, FilterSelect },
  data: () => {
    return {
      hospitalList: [], // 医院列表
      query: '', // 搜索的关键词
      /**
       *  5  "医院指南（原找医院）"
       *  1  "找医生"
       *  3  "权威专家"
       */
      fromType: '', // 进入此页面的位置 默认为医院指南进入
      province: '', // 省份
      city: '', // 城市
      clinicNo: '', // 一级科室
      secondClassClinicNo: '', // 二级科室
      hospitalGrade: [], // 医院等级
      hospitalNature: [], // 医院性质
      hospitalType: [], // 医院类别
      page: 1, // 页数
      isMore: true, // 是否有更多
      queryInfo: {}, // 查询信息
      shareInfo: {}, // 分享信息
      isBanner: '', // 是否是banner图进入（自诊自查）
      seeMore: '', // 是否是查看跟多进入（自诊自查）
      fromWxMini: '', // 是否是微信环境
      isApp: false, // 是否在端上
      filterOptions: [
        { name: '全国', isFocus: false, filterType: 'select', data: [] },
        { name: '科室', isFocus: false, filterType: 'select', data: [] },
        { name: '筛选', isFocus: false, filterType: 'filter', data: [] },
      ],
      filterValue: [
        ['', ''],
        ['', '', ''],
        ['', ''],
      ], // 筛选器的值
      isLoading: false, // 是否等待加载
      isTouchTop: true,
      secureId: '', // 打点用
      version: '', // 打点用
      isHeightFilter: false, // 是否高亮筛选
      currentClinicName: '', // 当前筛选的科室名
      pageReadableName: '医院列表页', // 数据上报等定义的页面名称
    };
  },
  computed: {
    // 打点用获取页面来源
    doPointFrom() {
      let from_type = '';
      if (this.fromType === '1') {
        from_type = '找医生';
      }
      if (this.fromType === '3') {
        from_type = '权威专家';
      }
      if (this.fromType === '5') {
        from_type = '找医院';
      }
      if (this.fromType === '4') {
        from_type = '自诊自查';
      }
      return from_type;
    },
    // 来源页面名称
    fromVisitPage() {
      return this.$route.query.from_visit_page || this.doPointFrom || '';
    },
  },
  mounted() {
    // 监听页面滑动，为筛选器设置筛选器
    window.addEventListener(
      'scroll',
      e => {
        const pacterDom = document.querySelector('.filter.pacter');
        if (this.fromType !== '4' && this.fromType !== '5') {
          return;
        }
        // console.log(e);
        // if (!e || e.target.id !== 'hospital-warp') {
        //   return;
        // }
        const { scrollTop } = e.target;
        const imgHeight = document.getElementById('sort-edu-img')
          ? document.getElementById('sort-edu-img').offsetHeight
          : 154;
        const filter = document.getElementById('filter');
        if (scrollTop >= imgHeight) {
          if (pacterDom) {
            pacterDom.style.display = 'block';
          }
          document.querySelector('.filter.pacter').style.display = 'block';
          filter.classList.add('fixed');
        } else {
          if (pacterDom) {
            document.querySelector('.filter.pacter').style.display = 'none';
          }
          filter.classList.remove('fixed');
        }
      },
      true
    );
  },
  created() {
    this.secureId = this.$route.query.secureId || this.$route.query.cyudId;
    this.version = this.$route.query.version || '';
    this.fromWxMini = cyDetect.isFromWechat() ? '1' : '';
    this.isApp = cyDetect.isFromCYAll();
    this.getParamsOfUrl();
    this.searchOptionList();
    this.getClinicList();
    this.getLocation();
    this.gethHospitalList();
    doPoint('PageView', {
      page_readable_name: this.pageReadableName,
      from_type: this.doPointFrom,
    });
    // 上报访问路径
    visitRecordReport({
      fromName: this.fromVisitPage,
      name: this.pageReadableName || '',
      extraInfo: {},
    });
    // 解决ios返回页面不刷新BUG
    window.addEventListener('pageshow', () => {
      document.title = '医院列表';
      // 页面刷新操作
      this.getParamsOfUrl();
    });
  },
  methods: {
    /**
     * 筛选器下拉框的显示隐藏回调事件
     */
    optionItemChange() {
      const filter = document.getElementById('filter');
      if (!filter.getAttribute('class').includes('fixed')) {
        this.$refs.list.initStatus(
          document.getElementById('sort-edu-img')
            ? document.getElementById('sort-edu-img').offsetHeight
            : 154
        );
      }
    },
    /**
     * 获取医院列表
     *
     * @param {boolean} isResetPage 是否重置搜索结果
     */
    gethHospitalList(isResetPage) {
      if (this.isLoading) return;
      this.isLoading = true;
      if (isResetPage) {
        this.$refs.list.initStatus();
      }
      this.page = isResetPage ? 1 : this.page;
      if (
        this.hospitalGrade.length ||
        this.hospitalNature.length ||
        this.hospitalType.length
      ) {
        this.isHeightFilter = true;
      }
      const params = {
        app: cyDetect.isFromCY() ? '0' : 'weixin_mini',
        query: this.query,
        from_type: this.fromType,
        province: this.province,
        city: this.city,
        clinic_no: this.clinicNo,
        second_class_clinic_no: this.secondClassClinicNo,
        hospital_grade: JSON.stringify(this.hospitalGrade),
        hospital_nature: JSON.stringify(this.hospitalNature),
        hospital_type: JSON.stringify(this.hospitalType),
        page: this.page,
        from_wx_mini: this.fromWxMini,
        secureId: this.secureId,
      };
      if (!cyDetect.isFromCY()) {
        params.platform = 'weixin_mini';
      } else {
        params.version = this.version || '';
      }
      searchHospital(params)
        .then(res => {
          this.isLoading = false;
          const { error_code, error_msg, data } = res;
          if (error_code === 0) {
            const { hospital_list, is_more, query_info, share_info } = data;
            if (this.query) {
              this.filterValue.splice(1, 1, [
                query_info.clinic_no,
                query_info.second_class_clinic_no,
                query_info.clinic_name,
              ]);
              this.clinicNo = query_info.clinic_no;
              this.secondClassClinicNo = query_info.second_class_clinic_no;
              this.query = query_info.query;
              if (query_info.province_code || query_info.city_code) {
                this.getLocation(
                  query_info.province_code || '',
                  query_info.city_code || '',
                  true
                );
              }
            }
            this.queryInfo = query_info;
            this.shareInfo = share_info;
            this.setShare(this.fromType === '5' || this.fromType === '4');
            this.hospitalList = isResetPage
              ? hospital_list
              : [...this.hospitalList, ...hospital_list];
            this.isMore = is_more;
          } else {
            this.isMore = false;
            this.$createToast({
              time: 1000,
              txt: error_msg || '获取医院列表失败',
              type: 'txt',
            }).show();
          }
        })
        .catch(() => {
          this.isMore = false;
          this.isLoading = false;
          this.$createToast({
            time: 1000,
            txt: '获取医院列表失败',
            type: 'txt',
          }).show();
        });
    },
    /**
     * 输入框回车监听事件
     */
    queryHospitalList() {
      this.queryReplace();
    },
    /**
     * 获取url上的参数（来源、搜索参数）
     *
     * @param {string} provinceOut 选择的省
     * @param {string} cityOut  选择的市
     * @param {boolean} isRepeat 是否重新加载
     */
    getParamsOfUrl(provinceOut, cityOut, isRepeat) {
      const {
        query,
        from_type,
        city,
        province,
        clinic_no,
        second_class_clinic_no,
        hospital_grade,
        hospital_nature,
        hospital_type,
      } = this.$route.query;
      const gradeArr = hospital_grade ? hospital_grade.split(',') : [];
      const natureArr = hospital_nature ? hospital_nature.split(',') : [];
      const typeArr = hospital_type ? hospital_type.split(',') : [];
      if (isRepeat) {
        this.filterValue.splice(0, 1, [provinceOut || '', cityOut || '']);
        return;
      }
      this.filterValue = [
        [province || '', city || ''],
        [clinic_no, second_class_clinic_no],
        {
          hospital_grade: gradeArr,
          hospital_nature: natureArr,
          hospital_type: typeArr,
        },
      ]; // 筛选器的值
      this.query = query || '';
      this.fromType = from_type || '5';
      this.city = city || '';
      this.province = province || '';
      this.clinicNo = clinic_no || '';
      this.secondClassClinicNo = second_class_clinic_no || '';
      this.hospitalGrade = gradeArr || '';
      this.hospitalNature = natureArr || [];
      this.hospitalType = typeArr || [];
    },
    /**
     * 触底后加载新数据连接在旧数据之后
     */
    loadMore() {
      console.log(this.isMore, this.isLoading);
      if (this.isMore && !this.isLoading) {
        this.page += 1;
        this.gethHospitalList();
      }
    },
    /**
     * 医院卡片点击事件，根据不同的入口跳转到不同的页面
     *
     * @param {object} hospitalInfo 医院基本信息
     */
    onHospitalCard(hospitalInfo) {
      if (!this.clinicNo && !this.secondClassClinicNo) {
        this.currentClinicName = '科室';
      }
      const that = this;
      doPoint('AppClick', {
        page_readable_name: this.pageReadableName,
        click_position:
          hospitalInfo.index <= 4
            ? `医院NO${hospitalInfo.index + 1}`
            : '医院剩余',
        click_position_value: hospitalInfo.name,
        from_type: this.doPointFrom,
      }).finally(() => {
        if (this.fromType === '5') {
          // 跳转医院详情页
          window.location.href = `/api/search/hospital/hospital_detail/?hospital_id=${
            hospitalInfo.hospital_id
          }&from_type=5&cyudId=${this.$route.query.cyudId ||
            ''}&from_visit_page=${this.pageReadableName}`;
          return;
        }
        if (this.fromType === '1') {
          try {
            if (this.fromWxMini) {
              wx.miniProgram.getEnv(wxres => {
                if (wxres.miniprogram) {
                  wx.miniProgram.navigateTo({
                    url: `/pages/find_doctor_list/index?query=${hospitalInfo.name}&input_type=医院筛选&first_clinic_no=${that.clinicNo}&second_clinic_no=${that.secondClassClinicNo}&clinic_name=${that.currentClinicName}&show_item_type_id=2&from_visit_page=${this.pageReadableName}`,
                  });
                }
              });
              return;
            }
          } catch (err) {
            console.log(err);
          }
          if (this.isApp) {
            window.location.href = `
              chunyu://launch/webapp/search_doctor/list?query=${hospitalInfo.name}&first_clinic_no=${this.clinicNo}&second_clinic_no=${this.secondClassClinicNo}&input_type=医院筛选&clinic_name=${this.currentClinicName}
            `;
          }
          return;
        }
        if (this.fromType === '3') {
          // 携带医院名称&科室筛选项跳转到【权威专家搜索结果页】
          window.location.href = `/v-m-general/authoritative-expert?is_result=1&clinic_no=${this.clinicNo}&second_class_clinic_no=${this.secondClassClinicNo}&query=${hospitalInfo.name}&input_type=医院筛选&do_point_str=医院列表&from_visit_page=${this.pageReadableName}`;
          return;
        }
        window.location.href = `/api/search/hospital/hospital_detail/?hospital_id=${hospitalInfo.hospital_id}&from_type=5&from_visit_page=${this.pageReadableName}`;
      });
    },
    getLocation(provinceCode, cityCode, isRepeat) {
      let province = '';
      let city = '';
      // 获取地区信息
      getLocation().then(res => {
        const { error_code, data } = res;
        if (error_code === 0) {
          const location = [];
          data.forEach(ele => {
            province = provinceCode === ele.code ? ele.text : province;
            const arr = ele.sub_data.map(item => {
              city = cityCode === item.code ? item.text : city;
              return {
                text: item.text,
                value: item.text,
              };
            });
            arr.unshift({
              text: ele.text,
              value: '',
            });
            const obj = {
              text: ele.text,
              value: ele.text,
              childer: arr,
            };
            location.push(obj);
          });
          location.unshift({
            text: '全国',
            value: '',
            childer: [{ text: '全国', value: '' }],
          });
          this.filterOptions[0].data = location.length ? location : [];
          this.getParamsOfUrl(province, city, isRepeat);
        }
      });
    },
    /**
     * 获取科室信息
     */
    getClinicList() {
      searchClinicList().then(res => {
        const { error_code, data } = res;
        if (error_code === 0) {
          const clinicList = [];
          data.forEach(ele => {
            const arr = ele.second_class_clinics.map(item => {
              if (
                ele.clinic_no === this.clinicNo &&
                item.clinic_no === this.secondClassClinicNo
              ) {
                this.currentClinicName = item.clinic_no
                  ? item.clinic_name
                  : ele.clinic_name;
              }
              return {
                text: item.clinic_name,
                value: item.clinic_no,
              };
            });
            const obj = {
              text: ele.clinic_name,
              value: ele.clinic_no,
              childer: arr,
            };
            clinicList.push(obj);
          });
          this.filterOptions[1].data = clinicList;
          this.getParamsOfUrl();
        }
      });
    },
    /**
     * 获取筛选信息
     */
    searchOptionList() {
      searchOptionList({ from_type: this.fromType }).then(res => {
        const { error_code, data } = res;
        if (error_code === 0) {
          data.option_list.forEach(item => {
            if (
              item.key === 'hospital_type' ||
              item.key === 'hospital_nature'
            ) {
              item.options.forEach(e => {
                e.value = `${e.value}`;
              });
            }
          });
          this.filterOptions[2].data = data.option_list;
        }
        this.getParamsOfUrl();
      });
    },
    /**
     * 筛选框发生改变的回调函数
     *
     * @param {Array} value 改变后的值
     */
    onFilterChange(value) {
      this.filterValue = value;
      const [
        [province, city],
        [clinic_no, second_class_clinic_no],
        { hospital_grade, hospital_nature, hospital_type },
      ] = value;
      this.hospitalGrade = hospital_grade;
      this.hospitalNature = hospital_nature;
      this.hospitalType = hospital_type;
      this.clinicNo = clinic_no;
      this.secondClassClinicNo = second_class_clinic_no;
      this.province = province;
      this.city = city;
      this.queryReplace();
      // this.gethHospitalList(true);
    },
    /**
     * 设置分享
     *
     * @param {boolean} isShare 是否可以分享
     */
    setShare(isShare) {
      if (this.fromWxMini) {
        try {
          wx.miniProgram.getEvn(wxres => {
            if (wxres.miniprogram) {
              wx.miniProgram.postMessage({
                data: {
                  img: this.shareInfo.image || '', // 分享的图片展示
                  title: this.shareInfo.title || window.document.title, // 标题
                  link: this.shareInfo.url, // 分享后点击卡片的跳转链接
                  origin: 'hospital-list', // 来源
                },
              });
            }
          });
        } catch (err) {
          console.log(err);
        }
        this.noMiniProgramShare(isShare);
        return;
      }
      this.noMiniProgramShare(isShare);
    },
    /**
     * 非小程序下的分享设置
     *
     * @param {boolean} isShare 是否展示分享按钮
     */
    noMiniProgramShare(isShare) {
      const params = {
        btn_visible: isShare, // 客户端右上角分享按钮的可见性,默认true
        do_share: false, // 不立即弹出分享菜单，默认false
        need_param: {
          version: true, // 是否携带app版本号
        },
        // 开启端上指定功能
        share_to: ['weixin_haoyou', 'weixin_pengyouquan', 'qq', 'weibo'],
        title:
          `${this.shareInfo.title} ${this.shareInfo.subtitle}` ||
          '医院指南 春雨医生团队专业整理，权威推荐',
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
        img: this.shareInfo.image,
        mini_image:
          'https://staff.chunyu.mobi/@/media/images/2022/11/11/da90/11a2ddc1cf36_w750_h600_.png',
        wx_scene_timeline_desc:
          `${this.shareInfo.title} ${this.shareInfo.subtitle}` ||
          '医院指南 春雨医生团队专业整理，权威推荐',
      };
      if (this.fromWxMini) {
        cyShare.weixin({
          img: this.shareInfo.image,
          title: this.shareInfo.title,
          desc: this.shareInfo.subtitle,
          link: this.shareInfo.url,
          wx_scene_timeline_desc:
            `${this.shareInfo.title} ${this.shareInfo.subtitle}` ||
            '医院指南 春雨医生团队专业整理，权威推荐',
        });
      } else {
        cyShare.app(params);
      }
    },
    /**
     * 重定向到结果页， 刷新之后也不会清除筛选条件
     */
    queryReplace() {
      const url = `/v-m-general/hospital-list?from_type=${
        this.fromType
      }&clinic_no=${this.clinicNo || ''}&second_class_clinic_no=${this
        .secondClassClinicNo || ''}&query=${this.query || ''}&sort_type=${this
        .sortType || ''}&hospital_grade=${this.hospitalGrade.join(',') ||
        ''}&hospital_nature=${this.hospitalNature.join(',') ||
        ''}&hospital_type=${this.hospitalType.join(',') || ''}&city=${this
        .city || ''}&province=${this.province || ''}&secureId=${this.secureId ||
        ''}&version=${this.version || ''}&from_visit_page=${
        this.pageReadableName
      }`;
      window.location.replace(url);
    },
    /**
     * 关闭筛选器的回调
     */
    onClose() {
      this.getParamsOfUrl();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.hospital-content {
  height: 100vh;
  padding-top: rem(54);
  overflow: hidden;
  background: #f7f7f7;
}
.sort-edu-img {
  // padding: rem(15) 0;
  width: 100%;
  height: rem(120);
}
.sort-edu {
  display: flex;
  align-items: center;
  padding: rem(15) rem(15) rem(12) rem(15);
  color: #999;
  font-weight: 400;
  font-size: rem(12);
  line-height: rem(14);
  letter-spacing: 0;
  text-align: left;
  img {
    width: rem(11);
    height: rem(11);
    margin-right: rem(4);
  }
  span {
    margin-top: rem(2);
  }
}
.filter {
  z-index: 999;
  width: 100%;
  height: rem(40);
  margin-top: rem(-4);
  margin-bottom: rem(10);
  background: #fff;
}
.filter.margin-bot {
  margin-bottom: 0;
}
.fixed {
  position: fixed;
  top: rem(54);
}
.hospital-warp {
  width: 100%;
  height: calc(100vh - (54 / 37.5) * 1rem);
  overflow: scroll;
  background: #f7f7f7;
}
.hospital-warp.scroll-auto {
  padding-top: rem(40);
}
.nodata-bottom {
  padding: rem(10);
  color: #949494;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0;
  text-align: center;
}
.hospital-disease-tips {
  padding: rem(12) rem(15);
  color: #faa14d;
  text-align: left;
  background-color: #fef8f3;
}
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: rem(90);
  img {
    width: rem(120);
    height: rem(80);
    margin-bottom: rem(10);
  }
  span {
    color: #949494;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0;
  }
}
.filter.pacter {
  display: none;
}
</style>
